import { SIM_TICK_RATE } from '@steelwake/shared';

export const SIM_DT_MS = 1000 / SIM_TICK_RATE;

export interface AdvanceResult {
  /** Fixed steps to simulate this frame. */
  steps: number;
  /** Interpolation factor between the previous and current sim state, in [0, 1). */
  alpha: number;
  /** Remaining accumulated time in milliseconds. */
  acc: number;
}

/**
 * Fixed-step accumulator (CLAUDE.md: sim at 30 Hz, rendering decoupled and interpolating).
 * Long stalls (tab switches) are clamped so the sim never spirals trying to catch up.
 */
export function advance(
  acc: number,
  frameMs: number,
  dtMs: number = SIM_DT_MS,
  maxSteps = 5,
): AdvanceResult {
  let a = acc + Math.min(Math.max(frameMs, 0), 250);
  let steps = Math.floor(a / dtMs);
  if (steps > maxSteps) {
    steps = maxSteps;
    a = dtMs * maxSteps;
  }
  a -= steps * dtMs;
  return { steps, alpha: a / dtMs, acc: a };
}
